﻿import React, { FC } from 'react';
import { IAdminStudyDto } from '../../../../services/api/api-client';
import { useTranslation } from 'react-i18next';
import { ExpandedRowHeader } from '../../../../components/expandedRow/header/expandedRowHeader.component';
import { AppButton } from 'uikit/buttons';
import { formatDateRange, localFormat } from '../../../../helpers/date-helpers';
import { addDays } from 'date-fns';
import { ReactComponent as EditIcon } from 'src/assets/img/common/edit_20.svg';
import ExpandedRowSections from 'uikit/table/ExpandedRowSections';
import PropertiesList from 'uikit/propertiesList/PropertiesList';
import { BulletPoints } from 'uikit/BulletPoints';
import { isNullOrEmpty } from 'src/helpers/string-helper';

export const StudyDetailsSection: FC<{ study: IAdminStudyDto; onEdit: () => void }> = ({ study, onEdit }) => {
  const { t } = useTranslation('dev');

  return (
    <ExpandedRowSections.Section>
      <ExpandedRowHeader
        text={t('Admin.StudyList.Details.Caption')}
        rightHeader={
          <AppButton
            onClick={onEdit}
            variant={'icon-link'}
            colorSchema={'primary'}
            text={t('Admin.StudyList.Details.Action')}
            Icon={EditIcon}
          />
        }
      />
      <PropertiesList>
        <PropertiesList.Property name={t('Admin.StudyList.Details.Id')} value={study.id.toString().padStart(3, '0')} />
        <PropertiesList.Property name={t('Admin.StudyList.Details.CreatedAt')} value={localFormat(study.createdAt)} />
        <PropertiesList.Property name={t('Admin.StudyList.Details.StudyNumber')} value={study.studyNumber} />
        <PropertiesList.Property
          name={t('Admin.StudyList.Details.Period')}
          value={formatDateRange(study.startDate, addDays(study.startDate, study.duration))}
        />
        <PropertiesList.Property name={t('Admin.StudyList.Details.Duration')} value={study.duration.toString()} />
        <PropertiesList.Property
          name={t('Admin.StudyList.Details.PlannedPatients')}
          value={study.plannedPatients?.toString() ?? '-'}
        />
        <PropertiesList.Property
          name={t('Admin.StudyList.Details.Groups')}
          value={<BulletPoints values={study.groups.map((x) => x.title)} />}
        />
        <PropertiesList.Property name={t('Admin.StudyList.Details.Description')} value={study.description} />
        <PropertiesList.Property
          name={t('Admin.StudyList.Details.PrimaryObjectiveText')}
          value={isNullOrEmpty(study.primaryObjectiveText) ? '-' : study.primaryObjectiveText}
        />
      </PropertiesList>
    </ExpandedRowSections.Section>
  );
};
